import React, { useMemo } from 'react';
import { Tag } from 'antd';
import { ArrowRightOutlined, UserOutlined } from '@ant-design/icons';
import { findWarehouseById } from 'shared/utils/warehouses/find-warehouse-by-id';
import { useGetWarehousesForClientOffice } from 'client-app/api/warehouses/use-get-warehouses-for-client-office';
import styles from './cargo-item-status.module.scss';
import type { ICargoItemStatus } from './types';

export const CargoItemStatus: React.FC<ICargoItemStatus> = (props) => {
  const { type, from, to } = props;
  const { data: warehouses } = useGetWarehousesForClientOffice();

  const getTagProps = (): { color?: string; className?: string } => {
    switch (type) {
      case 'waiting':
        return { color: '', className: styles.tag };
      case 'planned':
        return { className: styles.plannedTag };
      case 'warehouse':
        return { className: styles.warehouseTag };
      case 'loaded':
        return { className: styles.loadedTag };
      case 'delivered':
        return { color: 'green', className: styles.tag };
    }
  };

  const getTagText = () => {
    const warehouseFrom = findWarehouseById(from, warehouses);
    const warehouseTo = findWarehouseById(to, warehouses);
    switch (type) {
      case 'waiting':
      case 'delivered':
        return type;
      case 'planned':
      case 'loaded':
        return (
          <>
            {type} {warehouseFrom?.name ?? <UserOutlined />}
            <ArrowRightOutlined className={styles.arrow} />
            {warehouseTo?.name ?? <UserOutlined />}
          </>
        );
      case 'warehouse':
        return `in ${warehouseFrom?.name}`;
    }
  };

  const tagProps = useMemo(getTagProps, [type]);
  const tagText = useMemo(getTagText, [type, from, to, warehouses]);

  return <Tag {...tagProps}>{tagText}</Tag>;
};
